import escapeRegExp from 'lodash/escapeRegExp';

export function getMailDomain(mail) {
  if (!mail) return null;
  const pos = mail.indexOf('@');
  if (pos === -1) return null;
  return `"${mail
    .slice(pos + 1)
    .trim()
    .toLowerCase()}"`;
}

export function validateEmail(email, domainRegex) {
  // eslint-disable-next-line no-useless-escape
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isValidEmail = re.test(String(email).toLowerCase());
  const isValidDomain = isEmailDomainRegexCompliant(email, domainRegex);
  return { isValid: isValidEmail && isValidDomain, isValidEmail, isValidDomain };
}

export function isEmailDomainRegexCompliant(email, domainRegex) {
  if (!email) return false;
  if (!domainRegex) return true;
  const isMatching = new RegExp(domainRegex, 'i').test(email);
  return isMatching;
}

/** HTML version used for testing
 * doesn't have the case insensitive flag, as it is NOT available;..
 */
export function isEmailDomainHtmlCompliant(email, domainRegex) {
  if (!email) return false;
  if (!domainRegex) return true;
  const isMatching = new RegExp(domainRegex).test(email);
  return isMatching;
}

const isLetter = new RegExp(/[a-zA-Z]/);

export function makeCaseInsensitive(regex) {
  return regex
    .split('')
    .map((letter) => {
      if (isLetter.test(letter)) {
        return `[${letter.toLowerCase()}${letter.toUpperCase()}]`;
      }
      return letter;
    })
    .join('');
}

export function getEmailDomainRegex({ whitelist = [], blacklist = [] }) {
  if (!whitelist.length && !blacklist.length) return;
  return whitelist.length
    ? `^.*@(${whitelist.map((d) => `(${makeCaseInsensitive(escapeRegExp(d))})`).join('|')})$`
    : `^.*@(${blacklist.map((d) => `(?!${makeCaseInsensitive(escapeRegExp(d))})`).join('')}.)*$`;
}

export const COMMON_B2C_EMAIL_DOMAINS = [
  'yahoo.com',
  'yahoo.fr',
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.fr',
  'outlook.com',
  'outlook.fr',
  'live.com',
  'live.fr',
  'msn.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'free.fr',
  'orange.fr',
  'wanadoo.fr',
  'laposte.net',
  'sfr.fr',
  'gmx.fr',
];

const getRawDomain = (email) => {
  if (!email) return null;

  const pos = email.indexOf('@');
  if (pos === -1) return null;

  return email
    .slice(pos + 1)
    .trim()
    .toLowerCase();
};

// Damerau-Levenshtein distance: same as Levenshtein but also counts an adjacent
// transposition (ex: "gmial" -> "gmail") as a single edit instead of two.
const damerauLevenshteinDistance = (a, b) => {
  const distances = [Array.from({ length: b.length + 1 }, (_, j) => j)];

  for (let i = 1; i <= a.length; i += 1) {
    distances[i] = [i];
    for (let j = 1; j <= b.length; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      let value = Math.min(distances[i - 1][j] + 1, distances[i][j - 1] + 1, distances[i - 1][j - 1] + cost);

      const isTransposition = i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1];
      if (isTransposition) {
        value = Math.min(value, distances[i - 2][j - 2] + 1);
      }

      distances[i][j] = value;
    }
  }

  return distances[a.length][b.length];
};

/**
 * Detects a likely typo in the email domain by comparing it to a list of well known
 * B2C domains (ex: "gmail.col" is 1 edit away from "gmail.com").
 * Returns the suggested domain, or null if the domain looks fine / isn't close to any reference domain.
 */
export const findSuggestedEmailDomain = (email, referenceDomains = COMMON_B2C_EMAIL_DOMAINS, maxDistance = 1) => {
  const domain = getRawDomain(email);
  if (!domain || referenceDomains.includes(domain)) return null;

  return referenceDomains.find((ref) => damerauLevenshteinDistance(domain, ref) <= maxDistance) || null;
};
